import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { firebaseReducer } from "react-redux-firebase";

import userReducer from "./user/user.reducer";
import faqReducer from "./faq/faq.reducer";
import gemeindeReducer from "./gemeinde/gemeinde.reducer";
import reportsReducer from "./reports/report.reducer";
import photoReducer from "./photo/photo.reducer";
import commentsReducer from "./comments/comment.reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [],
};

const rootReducer = combineReducers({
  user: userReducer,
  faq: faqReducer,
  gemeinde: gemeindeReducer,
  photo: photoReducer,
  reports: reportsReducer,
  comments: commentsReducer,
  firebase: firebaseReducer,
});

export default persistReducer(persistConfig, rootReducer);
